import { Navigate, Outlet } from "react-router-dom";
import { getToken, isValidJWT } from "../utils/token";


const RouteGuard = () => {

  if (!isValidJWT(getToken())) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RouteGuard;



